import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Alert, Skeleton, SkeletonLine, SkeletonBlock } from '@one-thd/sui-atomic-components';
import ReloadForm from './ReloadForm';
import { useGiftcardBalanceCheck } from '../../hooks/useGiftcardBalanceCheck';
import { getTmxId } from '../../utils/utils';

const ReloadSavedGiftCard = ({ savedPaymentId, cardLast4, onCancel }) => {
  const [gcCheckBalanceResponse, responseStatus] = useGiftcardBalanceCheck({
    isBulk: true
  });
  const { data, loading, error } = responseStatus;
  const balance = data?.balanceCheck?.balanceDetails[0].availableAmount;
  const availableAmount = balance ? parseFloat(balance) : 0;

  useEffect(() => {
    if (savedPaymentId) {
      gcCheckBalanceResponse({
        variables: {
          balanceCheck: {
            giftCard: [{ savedPaymentId }],
            localization: { primaryStoreId: '121' }
          },
          requestContext: {
            tmxProfileId: getTmxId()
          }
        }
      });
    }
  }, [savedPaymentId]);

  if (loading) {
    return (
      <div className="sui-w-full sui-grid sui-justify-center">
        <Skeleton>
          <SkeletonBlock aspect="wide" />
          <SkeletonLine numberOfLines={5} />
        </Skeleton>
      </div>
    );
  }

  if (!loading && error) {
    const errors = error?.graphQLErrors?.[0]?.extensions?.errors
      || error?.graphQLErrors?.[0]?.extensions?.customer_payment_info;
    const description = errors?.[0]?.description;
    return (
      <Alert status="error" data-testid="error-msg-save-card">
        {description}
      </Alert>
    );
  }

  return (
    <ReloadForm
      reloadableAmount={2000 - availableAmount}
      availableAmount={availableAmount}
      savedPaymentId={savedPaymentId}
      cardLast4={cardLast4}
      onCancel={onCancel}
      isDrawer
    />
  );
};

ReloadSavedGiftCard.propTypes = {
  onCancel: PropTypes.func,
  savedPaymentId: PropTypes.string,
  cardLast4: PropTypes.string
};

ReloadSavedGiftCard.defaultProps = {
  onCancel: () => {},
  savedPaymentId: '',
  cardLast4: ''
};

export { ReloadSavedGiftCard };
